<template>
  <div class="table-page-wrapper">
    <div v-show="searchStatus" class="search-wrapper">
      <search-dsp-select v-model="tableParams.dspId" />
      <el-input v-model="tableParams.appBundle"  clearable placeholder="请输入应用名称" style="width: 270px;" />
      <el-input v-model="tableParams.appName"  clearable placeholder="请输入应用名称" style="width: 270px;"
        @input="removeBlank(tableParams.appName, 'appName')" />
      <el-input v-model="tableParams.keyword"  clearable placeholder="请输入关键字（精确）" style="width: 270px;"
        @input="removeBlank(tableParams.keyword, 'keyword')" />
      <el-date-picker v-model="date" @change="changeDate" :default-time="defaultTime" type="datetimerange" unlink-panels
        style="margin-right: 15px;" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" align="right"
        :shortcuts="shortcuts" />

      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>
    <div style="width: 100%;height:80vh;background-color: white;">
      <div id="income" style="height:50vh"></div>
      <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
        :summary-method="tableSummary" show-summary highlight-current-row ref="report" size="small" class="js-table"
        style="width: 100%" @sort-change="sortChange">
        <el-table-column v-if="tableParams.showType === 1" prop="timeKey"
          :label="tableParams.showType === 1 ? '日期' : '时间'" sortable align="center" />
        <el-table-column v-for="(v, i) in columns" :prop="v.field" :label="v.title" :width="v.width"
          :min-width="v.minWidth" :key="i" align="center" :sortable="
            v.field === 'showSmt' ||
            v.field === 'reportTime' ||
            v.field === 'contactPhone' ||
            v.field === 'hit' ||
            v.field === 'win' ||
            v.field === 'winPrice' ||
            v.field === 'auctionPrice' ||
            v.field === 'clkSmt' ||
            v.field === 'expensesEcpm' ||
            v.field === 'expensesAge' ||
            v.field === 'incomeEcpm' ||
            v.field === 'incomeAge' ||
            v.field === 'clkAvg'
          ">
          <template v-slot="scope">
            <el-tag v-if="
              v.field === 'clickRate' &&
              scope.row[v.field] != 0
            " type="info">{{ scope.row[v.field] ? scope.row[v.field] + '%' : '' }}</el-tag>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>


  </div>
</template>

<script>
import TableColumn from '@/components/TableColumn'
import SearchDspSelect from '@/components/SearchDspSelect'
import BaseDatePicker from '@/components/BaseDatePicker'
import downExcelMixin from '@/mixins/downExcel'
import initTableMixin from '@/mixins/initTable'
import { uuid } from '@/util/util'
import { formatDate, NORM_DATETIME_MINUTE_PATTERN } from '@/util/format'
import zhCn from "element-plus/lib/locale/lang/zh-cn"
import { webReportBiddingPriceList } from '@/api/manage/keyword/bidReport'

import * as echarts from 'echarts/core';
import {
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent
} from 'echarts/components';
import { LineChart } from 'echarts/charts';
import { UniversalTransition } from 'echarts/features';
import { CanvasRenderer } from 'echarts/renderers';

echarts.use([
  TitleComponent,
  ToolboxComponent,
  TooltipComponent,
  GridComponent,
  LegendComponent,
  LineChart,
  CanvasRenderer,
  UniversalTransition
]);


export default {
  name: 'Manage/keyword/bidReport',
  components: {
    TableColumn,
    SearchDspSelect,
    BaseDatePicker
  },
  mixins: [initTableMixin, downExcelMixin],
  props: ['defaultDate'], // 默认时间
  data() {
    return {
      columns: [
        { field: 'timeKey', title: '日期' },
        { field: 'appBundle', title: '应用包名' },
        { field: 'appName', title: '应用名称' },
        { field: 'dspName', title: 'DSP名称' },
        { field: 'keyword', title: '关键字' },
        { field: 'maxPrice', title: '出价ecpm' },
      ],
      dateFormatOptions: [
        {
          dateFormatId: 0,
          label: '正常显示'
        },
        {
          dateFormatId: 1,
          label: '按日显示'
        }
      ],
      type: "",
      tey: false,
      defaultTime: [
        new Date(0, 0, 0, 0, 0, 0),
        new Date(0, 0, 0, 23, 0, 0),
      ],
      shortcuts: [
        {
          text: '最近一小时',
          value: (() => {
            let date = new Date();
            const end = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 59)
            const start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours())
            return [start, end]
          })()
        },
        {
          text: '最近三小时',
          value: (() => {
            let date = new Date();
            const end = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 59)
            const start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() - 3)
            return [start, end]
          })()
        },
        {
          text: '最近六小时',
          value: (() => {
            let date = new Date();
            const end = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), 59)
            const start = new Date(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours() - 6)
            return [start, end]
          })()
        },
        {
          text: '今天',
          value: (() => {
            const start = new Date(new Date().toLocaleDateString()).getTime()
            const end = start + 23 * 60 * 60 * 1000 + (59 * 60 * 1000)
            return [start, end]
          })()
        }, {
          text: '昨天',
          value: (() => {
            const start = new Date(new Date().toLocaleDateString()).getTime() - 3600 * 24 * 1000
            const end = start + 23 * 60 * 60 * 1000 + (59 * 60 * 1000)
            return [start, end]
          })()
        }, {
          text: '最近三天',
          value: (() => {
            const start = new Date(new Date().toLocaleDateString()).getTime() - 2 * 3600 * 24 * 1000
            const end = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000
            return [start, end]
          })()
        }, {
          text: '最近一周',
          value: (() => {
            const start = new Date(new Date().toLocaleDateString()).getTime() - 6 * 3600 * 24 * 1000
            const end = new Date(new Date().toLocaleDateString()).getTime() + 24 * 60 * 60 * 1000
            return [start, end]
          })()
        }],
      date: undefined,
      incomeChar: "",
      listData: [],
      option: {
        tooltip: {
          trigger: 'axis'
        },
        legend: {
          data: []
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        toolbox: {
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: 'category',
          boundaryGap: false,
          data: []
        },
        yAxis: {
          type: 'value'
        },
        series: []
      },
      timeFormat: ""
    }
  },
  created() {
    this.dateInit()

    this._webReportBiddingPriceList()
  },
  mounted() {
    // this.$nextTick(() => {
    //   this._webReportBiddingPriceList()
    // });
    window.onresize = () => {
      clearTimeout(this.timer);
      this.timer = setTimeout(() => {
        this.incomeChart.resize();
      }, 100);
    };
  },
  provide() {
    return {
      init: this.init
    }
  },

  methods: {
    afterInit(res) { },
    beforeInit() { },
    dateInit() {
      if (this.defaultDate) {
        this.date = this.defaultDate
      } else {
        this.date = [new Date(), new Date()]
      }
      this.changeDate()
    },
    changeDate() {
      const date = this.date
      if (!(date[0] instanceof Date)) {
        date[0] = date[0].$d
        date[1] = date[1].$d
      }
      date[0] = formatDate(this.date[0], NORM_DATETIME_MINUTE_PATTERN)
      date[1] = formatDate(this.date[1], NORM_DATETIME_MINUTE_PATTERN)
      if (date[0].substring(8, 10) === date[1].substring(8, 10)) {
        this.timeFormat = "Minute"
      } else if ((new Date(date[1]).getTime() - new Date(date[0]).getTime()) / (24 * 60 * 60 * 1000) < 7) {
        this.timeFormat = "Hour"
      } else {
        this.timeFormat = "Day"
      }
    },
    _webReportBiddingPriceList() {
      this.tableParams.startTime = this.date[0]
      this.tableParams.endTime = this.date[1]
      webReportBiddingPriceList(this.tableParams).then(res => {
        if (res.code == 200) {
          let arr = []
          let tableData = []
          let xAxis = []
          let legend = []
          let series = []
          for (let i in res.data) {
            let obj = { name: i, data: res.data[i] }
            arr.push(obj)
          }
          if (JSON.stringify(res.data) === "{}") {
            const chartDom = document.getElementById('income');
            this.incomeChart = echarts.init(chartDom);
            this.incomeChart.clear()
            this.option.legend.data = [];
            this.option.series = []
            this.option.xAxis.data = []
            this.option && this.incomeChart.setOption(this.option);
            this.tableData = []
            // this.incomeChart.setOption()
          } else {
            // 将
            arr.forEach((index, item) => {
              legend.push(index.name)
              index.data.forEach(index2 => {
                if (!xAxis.includes(index2.timeKey)) {
                  xAxis.push(index2.timeKey)
                  xAxis.sort(function (a, b) {
                    return a - b
                  })
                }
              })
              series[item] = {
                name: index.name,
                type: 'line',
                stack: 'Total',
              }
            })
            arr.forEach(index => {
              let obj = { name: index.name, arr: new Array(xAxis.length) }
              xAxis.forEach((i, v) => {
                index.data.forEach((i2, v2) => {
                  if (i == i2.timeKey) {
                    obj.arr[v] = Number(i2.maxPrice)
                  }
                })
              })
              series.forEach(index => {
                if (index.name == obj.name) {
                  index.data = obj.arr
                }
              })
              tableData.push(index.data)
            })
            this.option.series = series
            this.option.xAxis.data = xAxis
            this.option.legend.data = legend
            this.tableData = tableData.flat(1)
            const chartDom = document.getElementById('income');
            this.incomeChart = echarts.init(chartDom);
            this.incomeChart.clear()
            this.option && this.incomeChart.setOption(this.option);
          }
        }
      })
    },

    toQuery() {
      // const chartDom = document.getElementById('income');
      // this.incomeChart = echarts.init(chartDom);
      // this.option && this.incomeChart.setOption(this.option);
      this._webReportBiddingPriceList()
    },
    sortChange(column, prop, order) {
      if (column.order === "ascending") {
        this.tableParams.asc = column.prop
        this.tableParams.desc = ""
      } else if (column.order === "descending") {
        this.tableParams.desc = column.prop
        this.tableParams.asc = ""
      }
      this.init()
    },

    removeBlank(val, name) {
      this.tableParams[name] = val.replace(/^\s+|\s+$/gm, '')
    },

  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 40vh;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
